import { useEffect, useState } from 'react';

import { useSessionQuery } from '../MsalAccessProvider';

import { Routes, Route, Link } from 'react-router-dom';

import Survey from './Survey';
import Timestamp from 'react-timestamp';

import loading from '../../loading.gif';

function Surveys() {
  const {data, error, isError, isLoading } = useSessionQuery(`/cms/surveys`);
  const [ completeTimes, setCompleteTimes ] = useState({});

  useEffect(() => {
    // store complete flags that can update
    if(data) {
      setCompleteTimes(data.surveys.map(row => [row.id, row.time_completed]).reduce((obj, [key, val]) =>{obj[key] = val; return obj;}, {}));
    }
  }, [data]);

  // wait for initial pull
  if (isLoading) {
    return (
      <div className="flex flex-col my-8">
        <div className="flex justify-center pt-4 pb-2">
          <img alt="Loading..." src={loading} className='w-12' />
        </div>
      </div>
    );
  }
  
  if (isError) {
    return (
      <div className="flex flex-col my-8">
        <div className="text-center pt-4 pb-2">
          {error}
        </div>
        <div className="text-center pt-4 pb-2">
          Please contact us at csci@utrgv.edu from your UTRGV email.
        </div>
      </div>
    );
  }

  if (!data) {
    return <></>;
  }

  const toTimestring = t =>
    `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, '0')}-${String(t.getUTCDate()).padStart(2, '0')}`
    + `T${String(t.getUTCHours()).padStart(2, '0')}:${String(t.getUTCMinutes()).padStart(2, '0')}:${String(t.getUTCSeconds()).padStart(2, '0')}`
    + `.${String(t.getUTCMilliseconds()).padStart(3, '0')}Z`

  const completeSurvey = id => {
    setCompleteTimes(times => ({...times, [id]: toTimestring(new Date())}));
  };

  return (
    <>
      <Routes>
        <Route path='/' element={
          <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide">
            <div className="p-3 rounded bg-cod-gray-mid flex flex-col space-y-2">
              {data.surveys.map(({id, subject, number, section, closes}) => {
                const closed = new Date() > new Date(closes);
                const completed = completeTimes[id] != null;

                // completed takes precedence, then closed (both non-clickable)
                if (closed || completed) {
                  return (
                    <div key={id} className="grid grid-cols-2 justify-between border border-transparent bg-cod-lightgray p-3 my-1 w-full" >
                      <div className="my-auto">{subject} {number} {section}</div>
                      {completed ?
                      <div className="my-auto">
                          Completed <Timestamp date={completeTimes[id]} />
                      </div>
                      :
                      <div className="my-auto">Closed <Timestamp date={closes} /></div>
                      }
                    </div>
                  );
                }

                // then open
                return (
                  <Link
                    to={`${id}`}
                    key={id}
                    className="grid grid-cols-2 justify-between border border-transparent
                    bg-cod-gray p-3 my-1 w-full hover:border-current cursor-pointer" >
                    <div className="my-auto">{subject} {number} {section}</div>
                    <div className="my-auto">Open <em>(closes <Timestamp date={closes} />)</em></div>
                  </Link>
                )}
              )}
            </div>
          </div>}
        />
        <Route path=':sectionId/*'
          element={<Survey
                      surveys={data.surveys} completeTimes={completeTimes}
                      completeSurvey={completeSurvey}
                    />}
          />
      </Routes>
    </>
  );
}

export default Surveys;
